export function getCognitoErrors(cognitoExceptionType: string) {
  if (cognitoExceptionType === 'CodeMismatchException' || cognitoExceptionType === 'EnableSoftwareTokenMFAException') {
    return 'app.mfaCodeErrorMissmatch'
  }
  if (cognitoExceptionType === 'NetworkError') {
    return 'app.mfaCodeErrorNetwork'
  }
  return 'app.mfaCodeErrorGeneric'
}